import React from "react";
import RoleButtons from "../../../components/role-buttons";
import SubmitDecisionsButton from "../../../components/ui-building-blocks/buttons/submit-decisions";
import Styled from "components/finance/style";

function UiTitle(props) {
  const {
    isOwnRole,
    hasAccess,
    submitDecisionsLoading,
    submitDecisionsData,
    submitDecisions,
    financial_decisions,
    unaccepted_decisions,
    loading,
    isPreChecked,
    isRoundEnded,
  } = props;

  return (
    <Styled.TitleWrapper>
      <Styled.Title>
        Finance Decisions
        {isOwnRole === true && loading === false && (
          <RoleButtons type="finance" />
        )}
      </Styled.Title>
      {hasAccess === true && (
        <SubmitDecisionsButton
          id="finance-submit-decisions"
          tooltipPlacement="bottom"
          data={submitDecisionsData}
          isLoading={submitDecisionsLoading}
          onClick={submitDecisions}
          financial_decisions={financial_decisions}
          unaccepted_decisions={unaccepted_decisions}
          buttonComponent={Styled.SubmitDecisionButton}
          isPreChecked={isPreChecked}
          isRoundEnded={isRoundEnded}
        />
      )}
    </Styled.TitleWrapper>
  );
}

export default UiTitle;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/ui-title.js